const faqs = [
  {
    question: "¿Necesito experiencia previa para tomar este curso?",
    answer:
      "No. El curso está diseñado para mujeres en cualquier punto de su camino, ya sea que estés empezando o que lleves años sin ver resultados. Todo se explica paso a paso.",
  },
  {
    question: "¿Cuánto tiempo debo dedicarle al día?",
    answer:
      "Entre 20 y 40 minutos por día. Cada módulo está estructurado para que puedas avanzar sin sacrificar tus otras responsabilidades. La clave es la consistencia, no la cantidad de horas.",
  },
  {
    question: "¿Qué pasa si no me funciona?",
    answer:
      "Tienes 7 días de garantía. Si sientes que el curso no es para ti, escríbenos y te devolvemos tu dinero. Sin preguntas, sin complicaciones.",
  },
  {
    question: "¿El acceso es de por vida?",
    answer:
      "Sí. Una vez que compras el curso, tienes acceso para siempre. Incluye todas las actualizaciones futuras del programa sin costo adicional.",
  },
];

export default function FaqSection() {
  return (
    <section style={{ backgroundColor: "#0D0D0D" }}>
      <div className="max-w-3xl mx-auto px-4 md:px-8 py-16 md:py-24">
        <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl text-center text-cream mb-12 md:mb-16">
          Preguntas frecuentes
        </h2>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="rounded-lg p-5 md:p-6 border border-gold/20"
              style={{ backgroundColor: "#1C1C1C" }}
            >
              <h3 className="font-serif text-base md:text-lg text-gold mb-3 flex items-start gap-3">
                <span className="text-gold/60 mt-0.5">&#10022;</span>
                <span>{faq.question}</span>
              </h3>
              <p className="font-sans text-sm md:text-base text-cream/70 leading-relaxed pl-7">
                {faq.answer}
              </p>
            </div>
          ))}
        </div>
      </div>
      {/* Divider */}
      <div className="h-px bg-gold-gradient" />
    </section>
  );
}